
import { useState } from "react";
import library_img_1 from "../../assets/images/gallery/library/library1.jpg";
import library_img_2 from "../../assets/images/gallery/library/library2.jpg";
import library_img_3 from "../../assets/images/gallery/library/library3.jpg";
import library_img_4 from "../../assets/images/gallery/library/library4.jpg";
import library_img_5 from "../../assets/images/gallery/library/library5.jpg";
import library_img_6 from "../../assets/images/gallery/library/library6.jpg";
import library_img_7 from "../../assets/images/gallery/library/library7.jpg";
import ContentLayout from "../../components/ContentLayout";
import { Box, Grid, Typography } from "@mui/material";
import { ZoomInRounded } from "@mui/icons-material";
import TransitionsModal from "../../components/modal/modal";
import ImageSlider from "../../components/ImageSlider";
import ImageSlideshow from "../../components/ImageSlideShow";

type ImageType = {
  src: string;
  alt: string;
};

type InfraObect = {
  name: string;
  img: Array<ImageType>;
};

const librartData: Array<InfraObect> = [
  {
    name: "Library",
    img:[
      { src: library_img_2, alt: "library_img_2" },
      { src: library_img_3, alt: "library_img_3" },
      { src: library_img_4, alt: "library_img_4" },
      { src: library_img_5, alt: "library_img_5" },
      { src: library_img_6, alt: "library_img_6" },
      { src: library_img_1, alt: "library_img_1" },
      { src: library_img_7, alt: "library_img_7" },
    ]
  }
]

function Library() {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [sliderImages, setSliderImages] = useState<Array<ImageType>>();

  return (
    <>
      <ContentLayout>
        <Grid container spacing={2}>
          <Grid item xs={12} md={5}>
            <Box sx={{ position: "relative" }} >
              <ImageSlideshow
                sx={{}}
                images={librartData[0]?.img as Array<ImageType>}
                showCaption={false} showCount={false} />
              <Box
                sx={{
                  position: "absolute" as "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
                onClick={() => {
                  setTitle(librartData[0]?.name);
                  setSliderImages(librartData[0]?.img);
                  setOpen(true);
                } }
              >
                <ZoomInRounded
                  sx={{
                    color: "#fdd025",
                    zIndex: 99,
                    fontSize: "4rem",
                    "&:hover": {
                      fontSize: "6rem",
                    },
                  }} />
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} md={7}>
            <Typography variant="body2" textAlign="justify" mb={2} fontSize={"1rem"}>
              Modern College of Physiotherapy Library operates on an Open Access system, providing students and faculty with unrestricted access to the collection.
              Each book is uniquely identified by a library stamp bearing a sequential number (e.g., 01, 101).
              The library occupies a total area of 2800 square feet and offers dedicated spaces for various purposes: 
            </Typography>
            <Typography variant="body2" textAlign="justify" mb={2} fontSize={"1rem"}>
              <span style={{fontWeight:"bold"}}>General Reading Room: </span>A spacious area accommodating up to 100 students simultaneously.<br/> 
              <span style={{fontWeight:"bold"}}>Teachers' Reading Room: </span> A quiet space designated for faculty members.<br/> 
              <span style={{fontWeight:"bold"}}>Librarian's Room: </span> An office for library staff.<br/>
              These facilities, combined with the open-access policy, create a conducive environment for study, research, and academic pursuits.<br/>
              The library consists 1854 books including physiotherapy as well as medical and clinical sciences.
              The library also has access to various journals which will help the students to stay updated with the recent practices and evidences.
              The library has a well-equipped e- library which consists of approximately 700- 750 books. 
            </Typography>
          </Grid>
        </Grid>
      </ContentLayout>
      
      {sliderImages && (
        <TransitionsModal
          open={open}
          setOpen={setOpen}
          title={title}
          children={<Grid item xs={12} margin={"auto"}>
            <Box sx={{ width: "75%", margin: "auto" }}>
              <ImageSlider images={sliderImages} />
            </Box>
          </Grid>} />
      )}
    </>
  );
}

export default Library;
